import { CardApi } from 'components/Modals/CreditCard/types'
import { UserModel } from 'components/Modals/types'
import { UserProfileRecord } from 'context/AuthContext'
import { ChargebeeSubscriptionDto, CouponDto } from 'types/subscription'
import { Tenant } from 'types/tenant'
import {
    getApiRequest,
    postApiRequest,
    putApiRequest,
} from 'utils/fetch-helper'

export function parseChargebeeAmount(amount: number): number {
    return Number((amount / 100).toFixed(2))
}

export async function createChargebeeCustomer(
    tenant: Tenant | undefined,
    user_profile: UserProfileRecord | undefined,
    card?: CardApi
) {
    if (tenant && user_profile && user_profile.user) {
        let user: UserModel = user_profile.user
        let customerDto = {
            billingAddress: {
                billingAddressCity: user.city,
                billingAddressCompany: tenant.name,
                // billingAddressCountry: user.country, // invalid, i think this should be country code
                billingAddressEmail: user.email,
                billingAddressFirstName: user.firstName,
                billingAddressLastName: user.lastName,
                billingAddressLine1: user.street1,
                billingAddressLine2: user.street2,
                billingAddressPhone: user.phone,
                billingAddressState: user.state,
                billingAddressStateCode: user.zip,
                billingAddressZip: user.zip,
            },
            card: {},
            company: tenant.name,
            customerType: 'RESIDENTIAL',
            email: user.email,
            firstName: user.firstName,
            fraudFlag: 'SAFE',
            lastName: user.lastName,
            phone: user.phone,
            id: user.id,
        }

        if (card) {
            customerDto.card = {
                ...card,
                cardBillingAddr1: user.street1,
                cardBillingAddr2: user.street2,
                cardBillingCity: user.city,
                // cardBillingCountry: user.country,
                cardBillingState: user.state,
                cardBillingStateCode: user.zip,
                cardBillingZip: user.zip,
            }
        }
        return await postApiRequest(
            `/v1/chargebee/customers?tenantId=${tenant.id}`,
            customerDto
        )
    }
}

export async function createSubscription(
    customer_id: string,
    chargebeeDto: ChargebeeSubscriptionDto,
    coupon: CouponDto | undefined
) {
    return await postApiRequest(
        `/v1/chargebee/subscriptions?customerId=${customer_id}`,
        {
            autoCloseInvoices: true,
            autoCollection: 'ON',
            billingAlignmentMode: 'IMMEDIATE',
            invoiceImmediately: true,
            subscriptionItems: chargebeeDto.subscriptionItems,
            couponIds: setCoupons(coupon),
        }
    )
}

export async function updateSubscription(
    subscription_id: string,
    chargebeeDto: ChargebeeSubscriptionDto,
    coupon: CouponDto | undefined
) {
    return await putApiRequest(
        `/v1/chargebee/subscriptions/${subscription_id}`,
        {
            ...chargebeeDto,
            couponIds: setCoupons(coupon),
        }
    )
}

function setCoupons(coupon: CouponDto | undefined) {
    let coupons = []
    if (coupon && coupon.id) {
        coupons.push(coupon.id)
    }
    return coupons
}

export async function getCoupon(coupon_id: string) {
    return await getApiRequest(`/v1/chargebee/coupons/${coupon_id}`)
}
